export const links = {
    twitter: 'https://twitter.com/noshiro_piko',
    github: 'https://github.com/noshiro-pf',
};
